import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import { getAuthorizationToken } from "./storagehelper"
//pass new generated access token here

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

// axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("authUser")
      localStorage.removeItem("token")
      window.location.href = "/login"
    }
    return Promise.reject(error)
  }
)

const addToken = () => {
  axiosApi.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${getAuthorizationToken()}`
}

export async function get(url, config = {}) {
  addToken()
  return await axiosApi
    .get(url, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function post(url, data, config = {}) {
  addToken()
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function put(url, data, config = {}) {
  addToken()
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function del(url, config = {}) {
  addToken()
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function attachpatch(
  url,
  data,
  config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
) {
  return axiosApi.post(url, data, { ...config }).then(response => response.data)
}

export async function RedirectloginApi(url) {
  const token = localStorage.getItem("token")
  const headers = {
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  }
  // setTimeout(() => {
  return axiosApi.get(url, headers).then(response => response.data)
  // }, 1000)
  // return axios.get(, headers).then(response => response.data)
}

export async function exportFile(url, data, type) {
  try {
    const response = await axiosApi.post(url, data, {
      headers: {
        Authorization: `Bearer ${getAuthorizationToken()}`,
      },
      responseType: "blob",
    })
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    })
    const link = document.createElement("a")
    link.href = window.URL.createObjectURL(blob)
    link.download = `${type}`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    console.error("Error fetching the file:", error)
  }
}
